module.exports = __webpack_public_path__ + "static/media/signal-icon1.eba503dd.svg";